import { createModalContext } from "shared/components/vero-modal";

export const {
  useModalContext: useSendToEntradaModal,
  Provider: SendToEntradaModalProvider,
} = createModalContext();
